import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, Input, Output, EventEmitter, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatDialog } from '@angular/material/dialog';
import { ResourceType, Tag } from 'situview-webapi-client';
import { TaggingService, Utils } from 'src/app/services';
import { EditTagComponent } from '../edit-tag/edit-tag.component';

@Component({
  selector: 'tag-picker',
  templateUrl: './tag-picker.component.html',
  styleUrls: ['./tag-picker.component.scss']
})
export class TagPickerComponent implements OnInit {

  @Input() allTags: Tag[] = [];
  @Input() assignedTagIds: string[] = [];
  @Input() resourceType: ResourceType = ResourceType.Any;
  @Input() allowAddTag: boolean = false;
  @Output() removeTagRequest = new EventEmitter<Tag>();
  @Output() addTagRequest = new EventEmitter<Tag>();
  @ViewChild('tagInput') tagInput: ElementRef<HTMLInputElement> | null = null;
  public get tagFilter(): string { return this.tagInput?.nativeElement.value ?? ""; }
  public set tagFilter(value: string) {
    if (this.tagInput) {
      this.tagInput.nativeElement.value = value;
    }
  }
  addOnBlur = true;
  readonly separatorKeysCodes = [ENTER, COMMA] as const;

  public get assignedTags(): Tag[] {
    if (!this.assignedTagIds) return [];
    return this.assignedTagIds
      .map(t => this.taggingService.tagById(t) ?? new Tag)
      .filter(t => !!t?.id && t.isDeleted == false);
  }

  constructor(private taggingService: TaggingService,
    private dialog: MatDialog) { }

  ngOnInit(): void {
  }

  editTag(tag: Tag) {
    const dialogRef = this.dialog.open(EditTagComponent, { data: tag });
    dialogRef.afterClosed().subscribe(result => { });
  }

  addTag(event: MatChipInputEvent) {
    if (!this.allowAddTag) return;

    const name = (event.value || '').trim();
    let openEditor = !this.taggingService.tagByName(name)?.id;

    if (name) {
      this.taggingService.getOrCreateTag(name, this.resourceType).then((tag) => {
        if (tag?.id) {
          this.addTagRequest.emit(tag);
          if (openEditor) {
            this.editTag(tag);
          }
        }
      });
    }

    event.chipInput!.clear();
  }

  removeTag(tag: Tag) {
    this.removeTagRequest.emit(tag);
  }

  color(color: string) {
    if (color) {
      return Utils.isColorDark(color) ? "#fff" : "#000";
    }
  }

  autoCompleteSelected(event: MatAutocompleteSelectedEvent): void {
    const tag = event.option.value;
    if (tag !== undefined) {
      this.addTagRequest.emit(tag)
    };
  }

  filteredTags(): Tag[] {
    let filter = this.tagFilter.toLowerCase();
    return this.allTags?.filter(tag =>
      (tag.name?.toLowerCase()?.startsWith(filter)) &&
      (this.assignedTagIds.findIndex(ti => ti === tag.id) === -1))
  }

  public tagClass(tag: Tag): string {
    return this.background(tag?.backgroundColour ?? "") + ' ' + this.border(tag?.borderColour ?? "");
  }

  public background(index: string): string {
    return this.taggingService.tagBackgroundColourClassName(index);
  }

  public border(index: string): string {
    return this.taggingService.tagBorderColourClassName(index);
  }
}
